import { render, staticRenderFns } from "./named-pair.vue?vue&type=template&id=540c796c&scoped=true&"
import script from "./named-pair.vue?vue&type=script&lang=js&"
export * from "./named-pair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540c796c",
  null
  
)

export default component.exports